import { useContext } from 'react'

import { SalesEditorContext } from '../state/sales-editor'

export const useSalesEditor = () => {
  const context = useContext(SalesEditorContext)

  if (!context) {
    throw new Error('useSalesEditor must be used within a SalesEditorProvider')
  }

  return context
}
